import { config as gtmConfig } from "./gtm"

const config = {
  gtm: gtmConfig,
}

export { config }
